<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div class="d-flex">
          <div class="perma-section-input pl-2">{{ input }}</div>
          <div>
            <v-btn
              class="ex-remove-btn w-100 ma-0 mb-2"
              @click="remove()"
              color="error"
              dark
              large
              >Remove Chain</v-btn
            >
            <div class="perma-section text-center pt-3 pb-3">{{ method }}</div>
            <div class="open selector_chainlink">
              <div class="chin-edit">
                <v-btn
                  text
                  class="m-w chin-edit-icon"
                  @click="showOpenDialog()"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </div>
              <div>
                <p class="label mt-3 mb-3">Source: {{ source }}</p>
                <p class="label mt-3 mb-3">Method: {{ methodName }}</p>
                <div class="buttons-block">
                  <v-btn
                    :class="useProxy ? 'active' : 'inactive'"
                    class="buttons-block-item ma-0 pa-0"
                    >UP</v-btn
                  >
                  <v-btn
                    :class="switchProxy ? 'active' : 'inactive'"
                    class="buttons-block-item ma-0 pa-0"
                    >SP</v-btn
                  >
                  <v-btn
                    :class="useCookies ? 'active' : 'inactive'"
                    class="buttons-block-item ma-0 pa-0"
                    >UC</v-btn
                  >
                  <v-btn
                    :class="clearSession ? 'active' : 'inactive'"
                    class="buttons-block-item ma-0 pa-0"
                    >CS</v-btn
                  >
                  <v-btn
                    :class="sentDelete ? 'active' : 'inactive'"
                    class="buttons-block-item ma-0 pa-0"
                    >SD</v-btn
                  >
                </div>
              </div>
            </div>
            <div class="col" v-show="result.length > 0">{{ result }}</div>
            <v-btn
              class="ex-add-btn w-100 ma-0 mt-2"
              @click="add()"
              color="success"
              dark
              large
              >Add Chain</v-btn
            >
          </div>
          <div class="perma-section-output pr-2">{{ output }}</div>
        </div>
      </v-flex>
    </v-layout>
    <!--    Dialog -->
    <v-dialog v-model="showOpenBlock" width="1000">
      <v-card>
        <v-card-title class="headline justify-space-between" dark-title>
          <div>Open</div>
          <v-btn text class="m-w ma-0" @click="showOpenBlock = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mb-3 open-block-modal">
          <ex-card disable-offsets>
            <template slot="header">
              <v-layout row justify-space-between>
                <v-flex sm5>
                  <div class="d-flex">
                    <p>Opening Source:</p>
                    <v-select
                      :items="variables"
                      item-text="id"
                      item-value="id"
                      v-model="source"
                      solo
                    />
                  </div>
                </v-flex>
                <v-flex sm6 class="d-flex">
                  <v-checkbox
                    v-model="useProxy"
                    label="Use proxy"
                    class="ma-0"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="switchProxy"
                    label="Switch proxy"
                    class="ma-0"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="useCookies"
                    label="Use Cookies"
                    class="ma-0"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row justify-end>
                <v-flex sm2>
                  <v-checkbox
                    v-model="clearSession"
                    label="Clear session"
                    class="ma-0"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex sm2>
                  <v-checkbox
                    v-model="sentDelete"
                    label="Sent DELETE"
                    class="ma-0"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row justify-space-between>
                <v-flex sm3 class="d-flex">
                  <v-btn v-if="useCookies" @click="toggleCookie()">{{
                    showCustomCookie ? "Use cookie file" : "Custom Cookie"
                  }}</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex sm12 class="d-flex">
                  <v-text-field
                    v-if="useCookies && !showCustomCookie"
                    v-model="cookie"
                    placeholder="Cookie"
                  />
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex sm3 class="d-flex">
                  <v-btn @click="customUser()">Custom User</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex sm12 class="d-flex">
                  <v-text-field
                    v-if="showCustomUser"
                    v-model="useragent"
                    placeholder="Custom User"
                  />
                </v-flex>
                <v-flex sm12 class="d-flex">
                  <v-text-field
                    v-model="waitForSelector"
                    placeholder="Wait for selector"
                  />
                </v-flex>
                <v-flex sm12 class="d-flex">
                  <v-text-field v-model="puppetClick" placeholder="Click" />
                </v-flex>
              </v-layout>
              <div class="i-v-input mt-4">
                <div v-if="!sentDelete">
                  <v-row>
                    <v-col sm="4">
                      <v-btn @click="addPostValue()">Add post</v-btn>
                    </v-col>
                    <v-col sm="4">
                      <v-select
                        label="Post Format"
                        :items="post_formats"
                        v-model="selected_post_format"
                        item-text="text"
                        item-value="value"
                        outlined
                        dense
                      ></v-select>
                    </v-col>
                  </v-row>
                  <div
                    class="d-flex align-center"
                    v-for="(data, i) in postData"
                    :key="i"
                  >
                    <v-text-field v-model="data.id" placeholder="key" />
                    <v-text-field v-model="data.value" placeholder="value" />
                    <v-icon @click="deletePostRow(i)">close</v-icon>
                  </div>
                </div>
                <div>
                  <v-btn @click="addHeaderValue()">Add header</v-btn>
                  <div
                    class="d-flex align-center"
                    v-for="(data, x) in headerData"
                    :key="x"
                  >
                    <v-text-field v-model="data.id" placeholder="key" />
                    <v-text-field v-model="data.value" placeholder="value" />
                    <v-icon @click="deleteHeaderRow(x)">close</v-icon>
                  </div>
                </div>
                <div>
                  <v-btn @click="excludeUrlEncoding()"
                    >Add character to exclude from encoding</v-btn
                  >
                  <div
                    class="d-flex align-center"
                    v-for="(data, x) in encExcludedData"
                    :key="x"
                  >
                    <v-text-field
                      v-model="encExcludedData[x]"
                      placeholder="value"
                    />
                    <v-icon @click="deleteEncExcludedRow(x)">close</v-icon>
                  </div>
                </div>
              </div>
            </template>
          </ex-card>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */
export default {
  name: "Open",
  props: ["x", "y", "variables"],
  data: () => ({
    showOpenBlock: false,
    postData: [],
    headerData: [],
    encExcludedData: [],
    waitForSelector: "",
    puppetClick: "",
    result: "",
    input: "",
    method: "curl",
    output: "text",
    source: "url",
    cookie: "",
    useragent: "",
    useProxy: false,
    switchProxy: false,
    useCookies: true,
    clearSession: false,
    sentDelete: false,
    showCustomCookie: true,
    showCustomUser: false,
    methodName: "GET",
    post_formats: [
      { text: "form-data", value: "form-data" },
      { text: "x-www-form-urlencoded", value: "x-www-form-urlencoded" },
      { text: "Text", value: "Text" },
      { text: "JSON", value: "JSON" },
    ],
    selected_post_format: "Text",
  }),
  watch: {
    postData: {
      handler() {
        if (this.postData.length > 0 && !this.sentDelete) {
          this.methodName = "POST";
        } else if (this.postData.length > 0 && this.sentDelete) {
          this.methodName = "DELETE";
        } else if (this.postData.length === 0 && !this.sentDelete) {
          this.methodName = "GET";
        }
      },
      deep: true,
    },
    sentDelete: function () {
      if (this.sentDelete) {
        this.methodName = "DELETE";
      } else if (this.postData.length > 0 && !this.sentDelete) {
        this.methodName = "POST";
      } else if (this.postData.length === 0 && !this.sentDelete) {
        this.methodName = "GET";
      }
    },
  },
  methods: {
    deletePostRow(index) {
      this.postData.splice(index, 1);
    },
    deleteHeaderRow(index) {
      this.headerData.splice(index, 1);
    },
    deleteEncExcludedRow(index) {
      this.encExcludedData.splice(index, 1);
    },
    customUser() {
      this.showCustomUser = !this.showCustomUser;
    },
    toggleCookie() {
      this.showCustomCookie = !this.showCustomCookie;
    },
    showOpenDialog() {
      this.showOpenBlock = true;
    },
    addPostValue() {
      console.log(this.postData);
      this.postData.push({ id: "", value: "" });
    },
    addHeaderValue() {
      this.headerData.push({ id: "", value: "" });
    },
    excludeUrlEncoding() {
      this.encExcludedData.push("");
    },
    add() {
      this.$emit("add", this.y, this.x);
    },
    remove() {
      this.$emit("remove", this.y, this.x);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/selector/Open.vue